import React, { useEffect, useMemo, useState } from 'react';
import { Guide } from '@/pages/home/components/Guide';
import { getLocale, useDispatch, useIntl, useLocation, useSelector } from 'umi';

import {
  OPINION_GUIDE_BOX_LIST6,
  OPINION_GUIDE_BOX_LIST6_PATH,
  OPINION_GUIDE_HIDE,
} from '@/pages/home/components/GuideModule/GuideOpinionBox';
import {
  GUIDE_TYPE_OPINION_DATA_SOURCE,
  GUIDE_SYS_OPINION,
} from '@/pages/home/models/guide';
import { storage } from '@/utils/utils';

import './index.scss';
import useOpinionGuideData from '@home/components/GuideModule/GuideOpinionBox/useOpinionGuideData';
import { useGetSingePageSourceRule } from '@op/hooks/useGetPageSourceRule';
const GuideComponent = () => {
  const [currentGuideStep, setCurrentGuideStep] = useState(-3);
  const { formatMessage } = useIntl();
  const locale = getLocale();
  const isEn = locale === 'en-US';
  const dispatch = useDispatch();
  const { guideType, userInfo, gameInfo } = useSelector((state: any) => {
    const {
      guide: { guideType },
      home: { userInfo },
      opinionCommon: { gameInfo },
    } = state;
    return {
      guideType,
      userInfo,
      gameInfo,
    };
  });

  const { excludeGuideSource } = useGetSingePageSourceRule({});
  const { GuideData } = useOpinionGuideData({
    gameInfo,
    userInfo,
    guidePermissions: excludeGuideSource,
  });

  // 注意下面两个useEffect不要合并到一起，不然会出现：从头部导航进入新手引导，点击到下一步时，关闭按钮无法关闭，而是返回到第一步
  useEffect(() => {
    if (guideType === GUIDE_TYPE_OPINION_DATA_SOURCE) {
      setCurrentGuideStep(0);
    }
  }, [guideType]);

  useEffect(() => {
    const list = storage.getLocalStorageItem(OPINION_GUIDE_BOX_LIST6) || [];
    const guideHide = storage.getLocalStorageItem(OPINION_GUIDE_HIDE);
    if (userInfo?.openid && !list.includes(userInfo.openid) && !guideHide) {
      setCurrentGuideStep(0);
    }
  }, [userInfo]);

  const onFinished = () => {
    if (userInfo.openid) {
      const list = storage.getLocalStorageItem(OPINION_GUIDE_BOX_LIST6) || [];
      !list?.includes(userInfo.openid) && list.push(userInfo.openid);
      storage.setLocalStorageItem(OPINION_GUIDE_BOX_LIST6, list);
    }
    dispatch({
      type: 'guide/showOpinionGuideModule',
      payload: true,
    });
  };

  const onCloseStep = () => {
    dispatch({
      type: 'guide/save',
      payload: {
        guideSys: GUIDE_SYS_OPINION,
        guideType: '',
      },
    });
  };

  const subtitle = formatMessage({
    id: 'Data Source and Metrics',
  });
  const { blockList } = GuideData;
  const rank = blockList.findIndex((item) => item.tit === subtitle) + 1;
  const title = `${formatMessage({ id: 'Core Function' })} ${rank}`;

  // const rank = gameInfo?.entity_type !== 'mobile' ? 5 : 6;

  const steps = useMemo(() => {
    const steps = [
      {
        element: () => document.querySelector('.user-guide-data-source-mask'),
        title,
        subtitle,
        description: formatMessage({
          id: 'You can view the details of all opinions data sources and the detailed definitions of all opinions metrics in the Opinions system.',
        }),
        placement: 'right',
        bubbleStyle: {},
      },
    ];

    return steps;
  }, [currentGuideStep, locale]);

  if (guideType !== GUIDE_TYPE_OPINION_DATA_SOURCE) return null;

  return (
    // finishText 根据中英文调整
    <Guide
      current={currentGuideStep}
      onCurrentChange={(
        current: number,
        context: {
          from: 'start' | 'back' | 'next' | 'finish' | 'cancel' | 'nodata';
        },
      ) => {
        const { from } = context;
        setCurrentGuideStep(current);
        if (from === 'finish' || from === 'nodata') {
          onFinished();
        } else if (from === 'cancel') {
          onCloseStep();
          onFinished();
        }
      }}
      visibleCloseBtn
      hideCancelButton
      showBackButton
      nextButtonTheme="primary"
      backText={formatMessage({ id: 'guide_last_step' })}
      nextText={formatMessage({ id: 'guide_next_step' })}
      finishText={formatMessage({ id: 'guide_more_step' })}
      steps={steps}
      showLoading={false}
    />
  );
};

export default () => {
  const location = useLocation();
  return (
    <>
      {OPINION_GUIDE_BOX_LIST6_PATH === location.pathname && <GuideComponent />}
    </>
  );
};
